import React from 'react'
import Richtext from '@/lib/rt/Richtext'
import quotation from '@/images/quotation.svg'

const TestimonialSection = ({ _rawRichtext, author, accent }) => {
		const style =
		accent === '#FFC28B' ? 'bg-orange-light' :
		accent === '#FFC42F' ? 'bg-sunshine' :
		accent === '#E4F9FA' ? 'bg-light-blue' :
		accent === '#F7E9D4' ? 'bg-tan text-orange' :
		accent === '#0F2938' ? 'bg-grounding-navy text-white' :
		accent === '#7FC7C5' ? 'bg-caribbean' :
		'bg-orange text-white'

	return (
		<section data-aos="fade-down" className={style}>
			<div className="section">
				<div className="mx-auto richtext">
					<figure>
						<img className="max-h-[40px] <md:max-h-[30px] mx-auto" src={quotation} alt="" />
					</figure>
					<Richtext className="h1 leading-tight" raw={_rawRichtext} />
					<p className="text-center technical">— {author}</p>
				</div>
			</div>
		</section>
	)
}

export default TestimonialSection
